import React, { useEffect, useState } from 'react'
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import Select from 'react-select';
import axios from 'axios';
import ToastNotification from '../../../components/ToastNotification';
import ConfirmDialog from '../../../components/ConfirmDialog';
import { useLoading } from '../../../context/LoadingContext';
import { GoDownload } from "react-icons/go";
import { Document, Packer, Paragraph, TextRun } from "docx";
import { saveAs } from "file-saver";

const Loan = () => {
    //==============useState===================
    const { setLoading } = useLoading();
    const [showForm, setShowForm] = useState(false);
    const [employeeList, setEmployeeList] = useState([]);
    const [loanList, setLoanList] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success'
    });
    const [confirmDialog, setConfirmDialog] = useState({
        show: false,
        title: '',
        message: '',
        onConfirm: null,
    });

    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    }

    const [formData, setFormData] = useState({
        emp_db_id: '',
        apply_date: getTodayDate(),
        loan_amount: '',
        period: '',
        loan_type: '',
        disbursed_on: '',
        interest: '',
        emi: '',
        total_payment: '',
        total_interest: '',
        approval_status: 'Pending',
          term_condition: `## Loan Terms and Conditions

1. The borrower must be 18 years or older and provide valid ID.
2. Loan funds will be disbursed after document verification.
3. Interest will accrue on the outstanding principal at the agreed rate.
4. Repayments must be made on time as per the schedule. Late payments may incur penalties.
5. Loan funds must be used only for the stated purpose.
6. This agreement is governed by the laws of [Your Country/State].
7. By accepting, the borrower agrees to all terms listed above.`,
        description:'',
    });

    const loanTypeOptions = [
        { value: 'Personal Loan', label: 'Personal Loan' },
        { value: 'Home Loan', label: 'Home Loan' },
        { value: 'Education Loan', label: 'Education Loan' },
        { value: 'Vehicle Loan', label: 'Vehicle Loan' },
    ];


    // =============handlers===================
    const showToast = (message, bg = 'success') => {
        setToast({ show: true, message, bg });
    };
    const showConfirmDialog = ({ title, message, onConfirm }) => {
        setConfirmDialog({
            show: true,
            title,
            message,
            onConfirm: () => {
                onConfirm();
                setConfirmDialog({ ...confirmDialog, show: false });
            },
        });
    };


    const handleFormOpen = () => {
        setShowForm(true);
    }


    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const resetForm = () => {
        setFormData({
            emp_db_id: '',
            apply_date: getTodayDate(),
            loan_amount: '',
            period: '',
            loan_type: '',
            disbursed_on: '',
            interest: '',
            emi: '',
            total_payment: '',
            total_interest: '',
            approval_status: 'Pending',
              term_condition: `## Loan Terms and Conditions

1. The borrower must be 18 years or older and provide valid ID.
2. Loan funds will be disbursed after document verification.
3. Interest will accrue on the outstanding principal at the agreed rate.
4. Repayments must be made on time as per the schedule. Late payments may incur penalties.
5. Loan funds must be used only for the stated purpose.
6. This agreement is governed by the laws of [Your Country/State].
7. By accepting, the borrower agrees to all terms listed above.`,
            description:'',
        });
        setShowForm(false);
        setIsEditing(false);
        setEditingId(null);
    };



    // emi calculator
    useEffect(() => {
        const { loan_amount, period, interest } = formData;

        const P = parseFloat(loan_amount) || 0;
        const n = parseInt(period) || 0;
        const r = parseFloat(interest) / 12 / 100 || 0;

        if (P > 0 && n > 0) {
            let emi = 0;

            // EMI formula
            if (r > 0) {
                emi = (P * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
            } else {
                emi = P / n;
            }

            const totalPayment = emi * n;
            const totalInterest = totalPayment - P;

            setFormData(prev => ({
                ...prev,
                emi: Math.round(emi),
                total_payment: Math.round(totalPayment),
                total_interest: Math.round(totalInterest),
            }));

        } else {
            setFormData(prev => ({
                ...prev,
                emi: '',
                total_payment: '',
                total_interest: '',
            }));
        }
    }, [formData.loan_amount, formData.period, formData.interest]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const payload = {
                ...formData,
                disbursed_on: formData.disbursed_on === '' ? null : formData.disbursed_on
            };

            if (isEditing) {
                const res = await axios.put(`https://api.skyguard.group/api/update-loan/${editingId}`, payload);
                showToast('Loan Updated Successfully', 'success');
          
                setLoanList(prev =>
                    prev.map(itm => itm.id === editingId ? { id: editingId, ...formData } : itm)
                );

            } else {
                const res = await axios.post('https://api.skyguard.group/api/add-loan', payload);
          
                showToast('Loan Added Successfully', 'success');

                setLoanList(prev => [
                    { id: res.data.insertId, ...formData },
                    ...prev
                ]);
            }
            fetchLoan();
            resetForm();

        } catch (error) {
            console.error(error);
            showToast('Error Adding Loan', 'danger');
        }
    }

    const handleEdit = (id) => {
        const data = loanList.find(item => item.id === id);

        setFormData({
            emp_db_id: data.emp_db_id || '',
            emp_id: data.emp_id || '',
            emp_name: data.emp_name || '',
            apply_date: data.apply_date ? data.apply_date.split('T')[0] : getTodayDate(),
            loan_amount: data.loan_amount || '',
            period: data.period || '',
            loan_type: data.loan_type || '',
            disbursed_on: data.disbursed_on ? data.disbursed_on.split('T')[0] : '',
            interest: data.interest || '',
            emi: data.emi || '',
            total_payment: data.total_payment || '',
            total_interest: data.total_interest || '',
            approval_status: data.approval_status || 'Pending',
            term_condition:data.term_condition || "",
            description:data.description || "",
        });

        setEditingId(id);
        setIsEditing(true);
        setShowForm(true);
    }

    const filteredData = loanList.filter(itm =>
        Object.values(itm).some(val =>
            String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
    )

    const handleDelete = async (id) => {
        try {
            const response = await axios.delete(`https://api.skyguard.group/api/delete-loan/${id}`)
            showToast('Loan deleted successfully', 'success');
            fetchLoan();
            setLoanList(prev => prev.filter(item => item.id !== id));

            if (isEditing && editingId === id) resetForm();

        } catch (error) {
            console.error('Error deleting loan:', error);
            showToast('Failed to delete loan', 'danger');
        }
    }

    // =================apis====================
    const fetchEmployeeData = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-employee');
            const data = res.data.result;
            // console.log(data);

            const formatted = data
             .filter(emp => emp.emp_id)   
            .map(emp => {
                const first = (emp.first || '').trim();
                const middle = (emp.middle || '').trim();
                const last = (emp.last || '').trim();

                const fullName = [first, middle, last].filter(Boolean).join(' ');
                return {
                    id: emp.id,
                    value: emp.emp_id,
                    label: emp.emp_id,
                    empName: fullName
                }
            });
            setEmployeeList(formatted);
        } catch (err) {
            console.error('Error fetching employee data:', err);
        }
    }

    const fetchLoan = async () => {
        setLoading(true);
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-loan');
            const sorted = Array.isArray(res.data.result)
                ? [...res.data.result].sort((a, b) => (Number(b.id) || 0) - (Number(a.id) || 0))
                : res.data.result;
            setLoanList(sorted);
            console.log(res.data.result);
        } catch (error) {
            console.error("Error fetching Loan", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchEmployeeData();
        fetchLoan();
    }, [])


    const handleDownloadLoanLetter = async (loan) => {
    if (!loan) return;

    const doc = new Document({
        sections: [
            {
                properties: {},
                children: [
                    new Paragraph({
                        children: [
                            new TextRun({ text: "LOAN APPROVAL LETTER", bold: true, size: 28 }),
                        ],
                        spacing: { after: 300 },
                    }),
                    new Paragraph({
                        children: [
                            new TextRun(`Date: ${new Date().toLocaleDateString()}`),
                        ],
                        spacing: { after: 300 },
                    }),
                    new Paragraph({
                        children: [
                            new TextRun({ text: "Employee Details", bold: true }),
                        ],
                        spacing: { after: 100 },
                    }),
                    new Paragraph(`Name: ${loan.emp_name}`),
                    new Paragraph(`Employee ID: ${loan.emp_id}`),
                    new Paragraph({ text: "" }),
                    new Paragraph({
                        children: [
                            new TextRun({ text: "Loan Details", bold: true }),
                        ],
                        spacing: { after: 100 },
                    }),
                    new Paragraph(`Loan Amount: ₹ ${loan.loan_amount}`),
                    new Paragraph(`Loan Type: ${loan.loan_type}`),
                    new Paragraph(`Period: ${loan.period} months`),
                    new Paragraph(`Interest Rate: ${loan.interest}%`),
                    new Paragraph(`Monthly EMI: ₹ ${loan.emi || '0.00'}`),
                    new Paragraph(`Total Payment: ₹ ${loan.total_payment || '0.00'}`),
                    new Paragraph(`Total Interest: ₹ ${loan.total_interest || '0.00'}`),
                    new Paragraph({ text: "" }),
                    new Paragraph({
                        children: [
                            new TextRun({ text: "Terms & Conditions", bold: true }),
                        ],
                        spacing: { after: 100 },
                    }),
                    new Paragraph(loan.term_condition || "N/A"),
                    new Paragraph({ text: "" }),
                    new Paragraph({
                        children: [
                            new TextRun({ text: "Description", bold: true }),
                        ],
                        spacing: { after: 100 },
                    }),
                    new Paragraph(loan.description || "N/A"),
                    new Paragraph({ text: "" }),
                    new Paragraph("This letter is issued for your record and confirmation of loan approval."),
                    new Paragraph({ text: "" }),
                    new Paragraph("Authorized Signatory"),
                    new Paragraph("Skyguard"),
                ],
            },
        ],
    });

    const blob = await Packer.toBlob(doc);
    saveAs(blob, `Loan_Letter_${loan.emp_id}.docx`);
};


    return (
        <>
            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <h3 className='my-3 fw-bold fs-5 golos'>Loan Apply</h3>

                    <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
                        <div className="col-12 col-md-5">
                            <input
                                type="text"
                                className="form-control border-0 border-bottom border-dark"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />

                        </div>
                        <div className="col-12 col-md-2 d-flex justify-content-end">
                            <button className='btn btn-success' onClick={handleFormOpen}>
                                <AiOutlinePlusCircle size={20} /> Apply Here
                            </button>
                        </div>
                    </div>
                    {showForm && (
                        <div className='card p-3 my-3 shadow-sm bg-white border'>
                            <form onSubmit={handleSubmit}>
                                <div className='row'>

                      {isEditing && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {formData.apply_date}
    </span>
  </div>
)}


                                    {/* left side */}
                                    <div className='col-md-6'>
                                        <div className='row g-3'>
                                            {/* Employee id */}
                                            <div className="col-12">
                                                <label className="form-label fw-medium">Select Emp ID</label>
                                                <Select
                                                    options={employeeList}
                                                    onChange={(selectedOption) => {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            emp_db_id: selectedOption.id,
                                                            emp_id: selectedOption.value,
                                                            emp_name: selectedOption.empName
                                                        }))
                                                    }}
                                                    value={employeeList.find(opt => opt.id === formData.emp_db_id) || null}
                                                />
                                            </div>
                                            {/* Loan Apply Date< */}
                                            <div className="col-12">
                                                <label className="form-label fw-medium">Loan Apply Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    name="leave_date"
                                                    value={formData.apply_date}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            {/* Amount/period    */}
                                            <div className="col-12">
                                                <div className='row g-2'>
                                                    <div className='col-md-6'>
                                                        <label htmlFor='loan_amount' className="form-label fw-medium">Loan Amount</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="loan_amount"
                                                            id='loan_amount'
                                                            value={formData.loan_amount}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <label htmlFor='period' className="form-label fw-medium">Period (Months)</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="period"
                                                            id='period'
                                                            value={formData.period}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* DisbursedOn */}
                                            <div className="col-12">
                                                <label htmlFor='disbursed_on' className="form-label fw-medium">Disbursed On</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    name="disbursed_on"
                                                    id='disbursed_on'
                                                    value={formData.disbursed_on}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div className="col-12">
                                                <div className='row g-2'>
                                                    <div className='col-md-6'>
                                                        <label>Term & Condition</label>
                                                        <textarea
                                                            type='text'
                                                            className="form-control"
                                                            name="term_condition"

                                                            value={formData.term_condition}
                                                            rows={3}
                                                            onChange={handleChange}
                                                        >

                                                        </textarea>
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <label>Description</label>
                                                        <textarea
                                                            type='text'
                                                            className="form-control"
                                                            name="description"

                                                            value={formData.description}
                                                            rows={3}
                                                            onChange={handleChange}
                                                        >

                                                        </textarea>

                                                    </div>

                                                </div> </div>
                                        </div>
                                    </div>
                                    {/* right-side */}
                                    <div className='col-md-6'>
                                        <div className='row g-3'>
                                            {/* Employee Name */}
                                            <div className="col-12">
                                                <label className="form-label fw-medium">Employee Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="emp_name"
                                                    value={formData.emp_name || ''}
                                                    readOnly
                                                />
                                            </div>
                                            {/* Select Loan Type */}
                                            <div className="col-12">
                                                <label className="form-label fw-medium">Select Loan Type</label>
                                                <Select
                                                    options={loanTypeOptions}
                                                    value={loanTypeOptions.find(opt => opt.value === formData.loan_type) || null}
                                                    onChange={(selectedOption) => {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            loan_type: selectedOption ? selectedOption.value : ''
                                                        }));
                                                    }}
                                                />

                                            </div>
                                            {/* Rate of Interest/ EMI(Rs.) */}
                                            <div className="col-12">
                                                <div className='row g-2'>
                                                    <div className='col-md-6'>
                                                        <label htmlFor='interest' className="form-label fw-medium">Rate of Interest(%)</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="interest"
                                                            id='interest'
                                                            value={formData.interest}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <label htmlFor='emi' className="form-label fw-medium">Monthly EMI(Rs.)</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="emi"
                                                            id='emi'
                                                            value={formData.emi}
                                                            onChange={handleChange}
                                                            readOnly
                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Total Payment/ total_interest    */}
                                            <div className="col-12">
                                                <div className='row g-2'>
                                                    <div className='col-md-6'>
                                                        <label htmlFor='total_payment' className="form-label fw-medium">Total Payment</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="total_payment"
                                                            id='total_payment'
                                                            value={formData.total_payment}
                                                            onChange={handleChange}
                                                            readOnly
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <label htmlFor='total_interest' className="form-label fw-medium">Total Interest(Rs.)</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="total_interest"
                                                            id='total_interest'
                                                            value={formData.total_interest}
                                                            onChange={handleChange}
                                                            readOnly
                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* save/Cancel */}
                                <div className='d-flex justify-content-center mt-4 gap-2'>
                                    <button type='submit' className='btn btn-success'>
                                        {isEditing ? 'UPDATE' : 'SAVE'}
                                    </button>
                                    <button type='button' className='btn btn-danger'
                                        onClick={() => {
                                            resetForm();
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}
                    {/* table-section */}
                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped text-center table-sm align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th>SL</th>
                                          <th>Action</th>
                                          <th>Apply Date</th>
                                    <th>Emp ID</th>
                                    <th>Emp Name</th>
                                    <th>Loan Amount</th>
                                    <th>Period(Months)</th>
                                    <th>Interest Rate</th>
                                    <th>Approval Status</th>
                              
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length > 0 ? (
                                    filteredData.map((loan, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                                  <td>
                                                <button className='btn btn-sm btn-primary mx-1' onClick={() => handleEdit(loan.id)}><AiOutlineEdit size={18} /></button>
                                                <button className='btn btn-sm btn-danger mx-1'
                                                    onClick={() =>
                                                        showConfirmDialog({
                                                            title: 'Delete Loan',
                                                            message: `Are you sure you want to delete "${loan.emp_name}" Loan ?`,
                                                            onConfirm: () => handleDelete(loan.id),
                                                        })
                                                    }
                                                >
                                                    <AiOutlineDelete size={18} />
                                                </button>
                                                <button
    className='btn btn-sm btn-success mx-1'
    onClick={() => handleDownloadLoanLetter(loan)}
>
    <GoDownload size={18}/>
</button>
                                            </td>
                                            <td>{loan.apply_date} </td>
                                            <td>{loan.emp_id}</td>
                                            <td>{loan.emp_name}</td>
                                            <td>{loan.loan_amount}</td>
                                            <td>{loan.period}</td>
                                            <td>{loan.interest}%</td>
                                            <td> {loan.approval_status === 'Approved' ? (
                                                <span className='badge bg-success'>{loan.approval_status}</span>
                                            ) : loan.approval_status === 'Rejected' ? (
                                                <span className='badge bg-danger'>{loan.approval_status}</span>
                                            ) : (
                                                <span className='badge bg-warning text-dark'>{loan.approval_status}</span>
                                            )}</td>
                                      
                                        </tr>
                                    ))) : (
                                    <tr>
                                        <td colSpan="8" className="text-center text-danger fw-bold text-muted">No data found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <ToastNotification
                show={toast.show}
                message={toast.message}
                bg={toast.bg}
                onClose={() => setToast({ ...toast, show: false })}
            />
            <ConfirmDialog
                show={confirmDialog.show}
                title={confirmDialog.title}
                message={confirmDialog.message}
                onConfirm={confirmDialog.onConfirm}
                onCancel={() => setConfirmDialog({ ...confirmDialog, show: false })}
            />

        </>
    )
}

export default Loan
